export default "__VITE_ASSET__35fe6b79__"